import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Form, Input, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  LOGIN_USER,
  DECRYPT_TOKEN,
  LOGIN_USER_TOKEN,
  LOGIN_SUCCESSFUL
} from "reducers/authReducer";
import { useHistory } from "react-router-dom";
import { RESET_REGISTRATION_SUCCESS } from "actions/Auth/actionTypes";
import { RootState } from "reducers/rootReducer";

interface LoginValue {
  username: string;
  pin: string;
}

function Login({ socket: ISocket }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [error, setError] = useState<String>("");
  const [loginForm] = Form.useForm();
  const {
    loginSuccessfull,
    registrationSuccess,
    registeredEmail,
    isLoading,
    decryptedToken,
  } = useSelector((state: RootState) => state.auth);
  const { search } = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(search);
    const token = query.get("token");
    if (token) {
      dispatch(DECRYPT_TOKEN({ payload: token }));
    } else if (localStorage.getItem("TOKEN")) {
      history.push("/dashboard");
      // console.log('token check before push')
    }
  }, []);

  useEffect(() => {
    if (registrationSuccess && registeredEmail) {
      dispatch({ type: RESET_REGISTRATION_SUCCESS });
      history.push("/auth/pin/verify");
    }
  }, [registrationSuccess]);

  useEffect(() => {
    if (decryptedToken) {
      const parsedToken = JSON.parse(decryptedToken);
      if (parsedToken.connectionId) {
        localStorage.setItem("RID", parsedToken.userId);
        localStorage.setItem("CID", parsedToken.connectionId);
        localStorage.setItem("TOKEN", parsedToken.connectionId);

        // dispatch(LOGIN_SUCCESSFUL({payload: true}));
        dispatch({ type: "LOGIN_SUCCESSFUL", payload: true });

        // history.push("/dashboard");
      } else {
        const payload = {
          userId: parsedToken.userId,
          password: parsedToken.password,
          deviceUdid: parsedToken.udid,
        };
        dispatch(LOGIN_USER_TOKEN(payload));
      }
    }
  }, [decryptedToken]);

  useEffect(() => {
    if (loginSuccessfull) {
      history.push("/dashboard");
    }
  }, [loginSuccessfull]);

  const onSubmitHandler = (values: LoginValue) => {
    const payload: LoginUserPayload = {
      email: values?.username?.toLowerCase(),
      password: values.pin + "",
      phoneNumber: "+92w3123322112",
    };
    dispatch(LOGIN_USER(payload));
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Form
      className="auth-form"
      name="login-form"
      id="login-form"
      layout="vertical"
      form={loginForm}
      onFinish={onSubmitHandler}
      onFinishFailed={onFinishFailed}
      requiredMark={false}
    >
      <h3>Sign in</h3>
      <p>Please enter your data here</p>
      <Form.Item
        name="username"
        rules={[{ required: true, message: "**Required Field" }]}
      >
        <Input type="text" placeholder="Phone or email" />
      </Form.Item>
      <Form.Item
        name="pin"
        hasFeedback
        rules={[{ required: true, message: "**Required Field" }]}
      >
        <Input type="password" placeholder="5-Digit Security PIN" />
      </Form.Item>
      {error && (
        <Form.Item>
          <p className="error">{error}</p>
        </Form.Item>
      )}
      <Form.Item>
        <Button loading={isLoading} type="primary" htmlType="submit">
          Sign in
        </Button>
      </Form.Item>
      <Form.Item className="mb-0">
        <p className="option-text">
          New to Beam? <Link to="/auth/register">Sign Up</Link>
        </p>
        <p className="option-text mb-0">
          Forgot Security PIN?{" "}
          <Link
            onClick={() =>
              dispatch({ type: "RESET_EMAIL_SENT", payload: undefined })
            }
            to="/auth/pin/reset"
          >
            Reset PIN
          </Link>
        </p>
      </Form.Item>
    </Form>
  );
}

export default Login;
